import { render, staticRenderFns } from "./HomeSelectionContainer.vue?vue&type=template&id=028d56f2&"
import script from "./HomeSelectionContainer.vue?vue&type=script&lang=js&"
export * from "./HomeSelectionContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports